import { PropsWithChildren } from "react";
import { classNames } from "../Utils/classNames.ts";
import { Footer } from "./Footer.tsx";
import { NormasTeachingLogo } from "./NormasTeachingLogo.tsx";

export function PublicLayout({
  children,
  maxWClass,
}: PropsWithChildren<{ maxWClass?: string }>) {
  return (
    <div className={"flex min-h-screen flex-col"}>
      <div
        className={"p-4 shadow-xl shadow-slate-200/10 w-full flex items-center"}
      >
        <NormasTeachingLogo />
      </div>
      <div className={"flex-1 bg-slate-100/50"}>
        <div
          className={classNames(
            "min-h-full flex flex-col p-4 mx-auto",
            maxWClass ? maxWClass : "max-w-[1024px]",
          )}
        >
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
}
